import MainPageConfigsGrid from '@components/marketing/mainPageConfig/MainPageConfigsGrid'
import React from 'react'
import { Col, Grid, Row } from 'rsuite'

import './MainPageConfigsPage.scss'

export default function MainPageConfigsPage () {
  return (
    <Grid fluid className="MainPageConfigsPage">
      <Row style={{ height: '100%'}}>
        <Col
          xs={24}
          sm={24}
          md={8}
        >
          <MainPageConfigsGrid />
        </Col>
       
        <Col 
          xs={24}
          sm={24}
          md={16}
        >
          <div>Предпросмотр</div>
        </Col>
        
      </Row>
    </Grid>
  )
}